
import Pagination from '~/components/Blog/Pagination.vue';
import BlogCard from '~/components/Blog/Card.vue'
export default {
  components:{
    Pagination,
    BlogCard
  },
 
  layout: 'blog',
  async asyncData({ store, route, payload }) {
  
    let pageNumber;
    if (typeof route.params.id !== 'undefined') {
      pageNumber = parseInt(route.params.id)
    }
    if (payload) return { posts: payload }
    else return {posts : await store.dispatch('posts/getPostbyPage',{ offset: Number(pageNumber)})}

  },
  computed: {offset(){
    return parseInt(this.$route.params.id)
  }},

}
